import React, { Component } from 'react';
import {HeartIcon} from '../shared/icons'
import {colors} from '../../shared/styles'

export class CheerResult extends Component {

  state = {
    hover: false,
  };

  onTouchTap = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.props.modal.handleTouchTap();
  };

  render() {
    const cheerCount = this.props.modal.props.cheerCount;
    const {hover} = this.state;

    return (
      <span
        onMouseEnter={() => this.setState({hover: true})}
        onMouseLeave={() => this.setState({hover: false})}
      >
        <HeartIcon
          onClick={this.onTouchTap}
          size={18}
          isFilled={cheerCount || hover}
          fill={cheerCount || hover ? colors.blue : colors.grey}
        >
        </HeartIcon>
      </span>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./components/control/CheerResult.js
 **/